import { documentsApprovalList } from "constants/documentsApproval";

const initialState = {
    documentsApprovalList: {},
};

const documentsApproval = (state = initialState, action) => {
    switch (action.type) {
        case documentsApprovalList:
            return { ...state, documentsApprovalList: action.payload };

        default:
            return state;
    }
};

export default documentsApproval;
